import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.AdvisorTypeEnumSortEnum>
) {
  const {
    pagination: { page, perPage },
    sort: { field, order },
  } = params;

  const {
    advisorTypeEnumList: { items: data, total },
  } = await sdk.getListAdvisorTypeEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage,
    },
    sort: [{ field, order }],
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { advisorTypeEnum: data } = await sdk.getOneAdvisorTypeEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { advisorTypeEnumMany: data } = await sdk.getManyAdvisorTypeEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const advisorTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
});
